<template>
  <div id="history-risk">
    <b-table
      :items="records"
      :fields="fields"
      :busy="loadingHistory"
      class="table-history-risk"
    >
      <template #cell(Detalles)="row" @click="row.toggleDetails">
        <template @click="row.toggleDetails">
          <a
            v-if="row.item.details[0]"
            size="sm"
            @click="row.toggleDetails"
            class="mr-2"
            style="cursor: pointer; color: #5d5fef; vertical-align: middle"
          >
            <img
              v-if="row.detailsShowing"
              class="centerImg1"
              src="@/assets/images/icons/arrow-drop-up-line.svg"
              width="20px"
            />

            <img
              v-else
              class="centerImg1 resaltar"
              src="@/assets/images/icons/eye-line.svg"
              width="20px"
            />

            {{ row.detailsShowing ? "Ocultar" : "Ver" }}
            Detalles
          </a>

          <p v-else>---</p>
        </template>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <OverlayButton clase="overlay-md"></OverlayButton>
        </div>
      </template>
      <template #row-details="row">
        <b-table :items="row.item.details" style="background-color: #f3f3f3" />
      </template>
    </b-table>
    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
      <Pagination
        :data="tableHistory"
        :limit="10"
        @pagination-change-page="paginateHistory"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
import { getLicenseHistory } from "@/services/modules/permisos-sindicales/v2/licenses/gestor-impuestos/service";
export default {
  components: {
    OverlayButton,
    Pagination,
  },
  props: {
    managementId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      records: [],
      fields: ["Id", "Tipo", "Fecha", "User", "Detalles"],
      loadingHistory: false,
      page: 1,
      tableHistory: {},
    };
  },
  methods: {
    async loadHistory() {
      const me = this;
      me.loadingHistory = true;
      try {
        const res = await getLicenseHistory(me.managementId, { page: me.page });
        me.tablePerson = res;
        res?.data.forEach((x) => {
          me.records.push({
            Id: x.id,
            User: x.user,
            Tipo: x.modification_type,
            Fecha: x.date,
            details: x.history,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.loadingHistory = false;
      }
    },
    paginateHistory(page) {
      const me = this;
      me.page = page;
      me.loadHistory();
    },
  },
  mounted() {
    const me = this;
    me.loadHistory();
  },
};
</script>

<style lang="scss" scoped>
.table-history-risk {
  box-shadow: 0 0 4px 2px transparent !important;
  border-radius: 0 !important;
}
</style>
